import { useService } from '@visiba/instantiation';
import { createContext, Fragment, ReactNode, useContext } from 'react';
import { PaymentController } from './payment.controller';

interface PaymentContext {
	controller: PaymentController;
}

const PaymentContext = createContext(undefined as unknown as PaymentContext);

export function PaymentContextProvider({ children }: { children: ReactNode }): JSX.Element {
	const paymentController = useService(PaymentController);
	const existingPaymentContext = useContext(PaymentContext);

	if (existingPaymentContext != null) {
		return <Fragment>{children}</Fragment>;
	}

	return (
		<PaymentContext.Provider
			value={{
				controller: paymentController,
			}}
		>
			{children}
		</PaymentContext.Provider>
	);
}

export function usePaymentContext(): PaymentContext {
	const context = useContext(PaymentContext);

	if (context == null) throw new Error('usePaymentContext must be used within a PaymentProvider');

	return context;
}
